//==========================Pre-loader=======================//
/*$(document).ready(function(){
	window.ajax_cart = true;
  	jQuery(window).load(function() { jQuery(".ttloader").fadeOut("slow"); });
});*/

//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//==================== account toggle ====================//
$(document).ready(function(){
	$(".user-background").click(function(){
	$('.cz_header-dropdown').toggleClass('active'); 
	});
});


//==================== cart toggle ====================//
$(document).ready(function(){
	$(".cart-text_block").click(function(){
	$(".site-header__cart .cart-content.block").slideToggle(800);
	$('.site-header__cart').toggleClass('active'); 
	});
});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


//=============================== Reviews Slider ==================================//

$('.quotes-slider.owl-carousel').owlCarousel({
    loop:false,
    margin: 0,
    nav: true,
  	dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})

//================================= testimonial append ==================================//

function testimonial_left() {
     $( ".side-bar.medium-up--one-quarter #shopify-section-cz-sidebar" ).append( $( ".testimonial" ) );
}

$(document).ready(function() {
    testimonial_left()
   
});

$(window).on("load", function() {
    testimonial_left();
});


//========================blog list slider==========================// 

$('#blog_slider.owl-carousel').owlCarousel({
    loop:true,
    margin: 0,
    nav:true,
  	dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        550:{
            items:2
        },
        990:{
            items:3
        }
    }
})

//====================== collection left product slider======================//

$('.left-slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
  	//margin:10,
    nav:true,
  	dots: false,
  	rows:1,
    responsive:{
        0:{
            items:1
        },
      	550:{
            items:2
        },
        990:{
            items:1
        }
    }
})

//====================== collection product slider======================//

$('.slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
  	//margin:10,
    nav:true,
  	dots: false,
  	rows:2,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
      	750:{
            items:3
        },
        1200:{
            items:4
        }
    }
})
//====================== collection product slider======================//

$('.tab-slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
  	//margin:10,
    nav:true,
  	dots: false,
  	rows:2,
    responsive:{
       	0:{
            items:1
        },
        480:{
            items:2
        },
      	750:{
            items:3
        },
        991:{
            items:4
        }
    }
})


/*=====================  More site navigation =======================*/
function more_left() {
  if ($(window).width() > 1600){
    var max_elem = 6;
    var items = $('.logo-align--left .header-center #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1269){
    var max_elem = 5;
    var items = $('.logo-align--left .header-center #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else {
    var max_elem = 4;
    var items = $('.logo-align--left .header-center #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more_left()
});

function more_center() {
  if ($(window).width() > 1600){
    var max_elem = 4;
    var items = $('.logo-align--center .header-left #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1269){
    var max_elem = 4;
    var items = $('.logo-align--center .header-left #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else {
    var max_elem = 3;
    var items = $('.logo-align--center .header-left #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more_center()
});


//================================= Related Product carousel ==================================//
$('.related.slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
  	margin:10,
    nav:true,
  	dots: false,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
      	750:{
            items:3
        },
        991:{
            items:4
        }
    }
})

$('.related.slider.owl-carousel').find('.owl-nav').removeClass('disabled');

//========================brand list slider==========================//
$('#brand-slider.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav: true,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:1
        },
        380: {
            items:2
        },
      	480:{
            items:3
        },
        750:{
            items:4
        },
        1200:{
            items:4
        }
    }
})

//=================================== Thumbnail product carousel ========================================//
$('#thumbnail-carousel.owl-carousel').owlCarousel({
    loop:true,
    margin: 10,
    nav:true,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:3
        },
      	480:{
            items:3
        },
      	600:{
            items:4
        },
        750:{
            items:3
        },
        1000:{
            items:4
        }
    }
})

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 115; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');
				jQuery('.category-box').addClass('home-category-fix');
				jQuery('.home-category').addClass('home-category-fix1');
				
			} else {
				jQuery('.header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');
				jQuery('.category-box').removeClass('home-category-fix');
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading").addClass('toggle');
    $(".side-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading").removeClass('toggle');
    $(".side-bar h3.box-heading").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1);


/*==================footer toggle====================*/

function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5").addClass('toggle');
    $(".footer-box .link_title").click(function(){
       $(this).parent().toggleClass('active').parent().find('.footer-content').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5").removeClass('toggle');
    $(".site-footer .footer-box h5").removeClass('active');
    $(".footer-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);



//======================mobile menu toogle======================//
$(document).ready(function(){

 
  $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
  
   $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
 		
});

/*================== sidebar category-box ===================*/
function mobileToggleMenu10(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu10);

function mobileToggleMenu11(){
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
}
$(document).ready(mobileToggleMenu11);


//------------------------------ Responsive left column------------------
function responsivecolumn()
{
	if ($(document).width() <= 990)
	{
		$('.main-content .page-width .contents .side-bar').insertAfter('.main-content .page-width .contents .main-container');
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });


//------------------------------ thumbnail-carousel ------------------
/*$(document).ready(function() {
    $('#blog_slider').bxSlider({
        mode: 'vertical',
        minSlides: 1,
        moveSlides: 2,
        slideMargin: 5,
        hideControlOnEnd: true,
        pager: false,
      	auto: true,
        touchEnabled: false,
        infiniteLoop: true,
    });
});*/

//============================ search toggle ==============================//
$(document).ready(function(){
	$(".header-search-btn").click(function(){
	$(".search-header").slideToggle(300); 
    $(".header-search-btn").toggleClass('active'); 
	});
});

$(document).ready(function(){
  $('.instagram').insertAfter('.cat_cms.bottom-cms');
  $('.footer-top').insertAfter('.instagram');
});

//==================== currency toggle ====================//
/*$(document).ready(function(){
	$(".currency-block").click(function(){
	$(".currency .currency-menu").slideToggle(500);
	$('.currency').toggleClass('active'); 
	});
});*/
 

//------------------------------ thumbnail-carousel ------------------
/*$(document).ready(function() {
    $('#thumbnail-carousel').bxSlider({
        mode: 'vertical',
        minSlides: 3,
        moveSlides: 1,
        slideMargin: 22,
        hideControlOnEnd: true,
        pager: false,
      	auto: true,
        touchEnabled: true,
        infiniteLoop: true,
    });
});*/


//=====================================Insert after-before =============================//
if ($(window).width() > 749) {
	$('.main-content .page-width .custom-content .custom__item-inner--text').insertBefore('.main-content .sub-container .product-container-collection .collection.collection-1');
}



  // jQuery code to add 'removeborder' class to the 'a' element
  jQuery(document).ready(function($) {
    // Find all 'div' elements with a 'td' descendant
    const divsWithTd = $('div:has(td)');

    // Loop through each matching 'div' element
    divsWithTd.each(function() {
      // Find the 'a' element with a 'img' child inside this 'div'
      const anchorWithImage = $(this).find('a:has(img)');
      
      // Add the 'removeborder' class to the 'a' element (if found)
      anchorWithImage.addClass('removeborder');
    });
  });


$(document).ready(function() {
    // Function to move the sidebar on mobile devices and wrap it
    function moveAndWrapSidebarOnMobile() {
        // Check if the window width is less than or equal to 767px
        if ($(window).width() <= 767) {
            console.log('Mobile width detected');

            // Check if the body has the class 'template-index'
            if ($('body').hasClass('template-index')) {
                console.log('Body has class template-index');

                // Check if the specific section exists
                var specificSection = $('#shopify-section-4293cb2b-b235-4605-b5d0-bacbedede159');
                var sidebar = $('#shopify-section-cz-sidebar');

                if (specificSection.length && sidebar.length) {
                    console.log('Specific section found for template-index');

                    // Create the wrapper div
                    var wrapper = $('<div class="side-bar"></div>');

                    // Insert the wrapper after the specific section
                    specificSection.after(wrapper);
                    console.log('Wrapper inserted after specified section');

                    // Move the sidebar into the wrapper
                    wrapper.append(sidebar);
                    console.log('Sidebar moved into the wrapper');
                } else {
                    console.log('Specific section or sidebar not found for template-index');
                }

            } else {
                console.log('Body does not have class template-index');

                // Check if the .title-breadcrumbs element exists
                var titleBreadcrumbs = $('.title-breadcrumbs');
                var sidebar = $('#shopify-section-cz-sidebar');

                if (titleBreadcrumbs.length && sidebar.length) {
                    console.log('.title-breadcrumbs element found');

                    // Create the wrapper div
                    var wrapper = $('<div class="side-bar"></div>');

                    // Insert the wrapper before the .title-breadcrumbs
                    titleBreadcrumbs.before(wrapper);
                    console.log('Wrapper inserted before .title-breadcrumbs');

                    // Move the sidebar into the wrapper
                    wrapper.append(sidebar);
                    console.log('Sidebar moved into the wrapper');
                } else {
                    console.log('.title-breadcrumbs or sidebar not found');
                }
            }
        } else {
            console.log('Not mobile width');
        }
    }

    // Initial check
    moveAndWrapSidebarOnMobile();

    // Check on window resize
    $(window).resize(function() {
        moveAndWrapSidebarOnMobile();
    });
});


$(document).ready(function() {
    var isToggling = false;

    $('h3.box-heading.toggle').click(function() {
        if (!isToggling) {
            isToggling = true;

            $('nav#CategoryBox h3.box-heading.toggle span.mobile_togglemenu').click();

            // Use a small timeout to reset the flag after the click event is processed
            setTimeout(function() {
                isToggling = false;
            }, 300); // Adjust timeout duration if necessary
        }
    });
});



$(document).ready(function() {
    $('a.btn--link.mobile-nav__link.submenu').click(function(event) {
        event.preventDefault(); // Prevent the default action of the link
        $(this).siblings('span.mobile_togglecolumn').click(); // Trigger the click on the sibling span
    });
});



